import { Pipe, PipeTransform } from '@angular/core';
import { FrontEndColumn } from '@app/shared/interfaces/front-end-column';
import { AttributeDTO } from '../models/AttributeDTO';

@Pipe({
  name: 'attributeName',
})
export class AttributeNamePipe implements PipeTransform {
  transform(text: string, column: FrontEndColumn[], attributes: AttributeDTO[]): any {
    if (text == null) {
      return '';
    }

    let result = '';
    column.forEach((a) => {
      if (a.name === text) {
        result = a.label ?? a.name;
      }
    });

    if(result === '') {
      attributes.forEach((a) => {
        if (a.name === text) {
          result = a.label ?? a.name;
        }
      });
    }

    if(result === '') {
      result = text;
    }

    return result;
  }
}
